<p-breadcrumb [model]="breadcrumb"></p-breadcrumb>
<div>
  <h1>Worklist</h1>
</div>
<main class="worklist-main">
  <div class="page-help-topics">
    <button pButton type="button" class="icon-action" icon="fa fa-question-circle" pTooltip="View Help Topics" tooltipPosition="top" (click)="help.toggle($event)"></button>
    <p-overlayPanel #help styleClass="page-help-interior">
      <h4><i class="fa fa-question-circle"></i> Help Topics</h4>
      <ul>
        <li><a (click)="helpOverview = true">How do I see an overview?</a></li>
        <li><a (click)="helpViewWorkList = true">How do I view my Worklist?</a></li>
        <li><a (click)="helpWorkItem = true">How do manage Worklist items?</a></li>
      </ul>
    </p-overlayPanel>
    <p-dialog [(visible)]="helpOverview" header="Show Me | WorkGroups: Overview" [responsive]="true" [modal]="true">
      <iframe *ngIf="helpOverview" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen height="315"
              src="https://www.youtube.com/embed/XusBB1Kiq1w?start=0;autoplay=1"
              width="560"></iframe>
    </p-dialog>
    <p-dialog [(visible)]="helpViewWorkList" header="Show Me | WorkGroups: Your Worklist" [responsive]="true" [modal]="true">
      <iframe *ngIf="helpViewWorkList" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen height="315"
              src="https://www.youtube.com/embed/XusBB1Kiq1w?start=287;autoplay=1"
              width="560"></iframe>
    </p-dialog>
    <p-dialog [(visible)]="helpWorkItem" header="Show Me | WorkGroups: Managing a Worklist Item" [responsive]="true" [modal]="true">
      <iframe *ngIf="helpWorkItem" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen height="315"
              src="https://www.youtube.com/embed/XusBB1Kiq1w?start=491;autoplay=1"
              width="560"></iframe>
    </p-dialog>
  </div>
  <div class="instruction-text">Please use the toggle button to manage worklist items for yourself or your workgroup.</div>
  <div class="p-grid">
    <div class="p-col-12 p-md-5 p-lg-5" style="margin-top:7px;">
      <p-selectButton [options]="worklistMenu"
                      [(ngModel)]="selectedWorklist"
                      (onChange)="handleWorklistToggle($event.value)"></p-selectButton>
    </div>

    <div *ngIf="activeTab === WorklistType.User || activeTab === WorklistType.Group">
      <div *ngIf="selectedWorklist===WorklistType.User && worklistCount[WorklistType.User]" class="p-col-12 p-md-2 p-lg-2">
        <div class="badge-set">
          <div class="p-col-4 p-md-4 p-lg-4">
            <div class="badge badge-submitted">{{user.worklistSubmittedOrApproved}}</div>
            <div class="badge-text">Awaiting Approval</div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="activeTab === WorklistType.MyTasks" class="p-col-12 p-md-4 p-lg-4">
      <div class="badge-set">
        <div class="p-col-4 p-md-4 p-lg-4" pTooltip="Pending Tasks" tooltipPosition="top">
          <div class="badge badge-submitted">{{pendingTasks ? pendingTasks : 0}}</div>
          <div class="badge-text">Pending Tasks</div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-col-12">
    <button pButton class="action-secondary" icon="fa fa-search" label="Search" (click)=" onClickSearch()">
    </button>
  </div>
  <div *ngIf="showSearch && (activeTab === WorklistType.User || activeTab === WorklistType.Group)" class="worklist-search searchPanel">
    <div class="p-grid">
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Category</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown name="categoryMenu" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [showClear]="true"
                        [options]="categoryMenu"
                        [(ngModel)]="searchOption.txnStructure"
                        (onChange)="onChangeTxnStructure(searchOption.txnStructure)"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Transaction Type</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown name="txnTypeMenu" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [showClear]="true"
                        [options]="txnTypeMenu"
                        [(ngModel)]="searchOption.txnType"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Ref Id</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText type="text" [size]="Validation.WorklistStringSize"
                   [(ngModel)]="searchOption.refId"/>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label pTooltip="Retrieve work items submitted AFTER this date" tooltipPosition="right">Submitted Date</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-calendar name="selectSubmittedDate" dataType="string" [dateFormat]="Format.PcalendarDate" [maxDate]="maxDate" icon="fa fa-calendar" showIcon="true"
                        [(ngModel)]="searchOption.submittedDate"></p-calendar>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label pTooltip="Retrieve work items due BEFORE this date" tooltipPosition="right">Due Date</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-calendar name="selectDueDate" dataType="string" [dateFormat]="Format.PcalendarDate" icon="fa fa-calendar" showIcon="true"
                        [(ngModel)]="searchOption.dueDate"></p-calendar>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Submitted By</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="selectSubmittedBy" type="text" [size]="Validation.WorklistStringSize"
                   [(ngModel)]="searchOption.submittedBy"/>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Submitted For</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="submittedFor" type="text" [size]="Validation.WorklistStringSize"
                   [(ngModel)]="searchOption.submittedFor"/>
          </div>
        </div>
      </div>
      <div class="p-col-12">
        <div class="p-grid">
          <div class="p-col-12 p-md-2 p-lg-2"></div>
          <div class="p-col-12 p-md-10 p-lg-10">
            <button pButton class="inaction-secondary" icon="fa fa-eraser" label="Clear"
                    (click)="onClickClearSearchOptionWorklist()">
            </button>
            <button pButton class="action-secondary" icon="fa fa-search" label="Search"
                    (click)="onClickSearchWorklist(selectedWorklist, searchOption)">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="showSearch && activeTab === WorklistType.MyTasks" class="worklist-search searchPanel p-grid" style="margin:5px;">
    <div class="p-col-12 p-md-6 p-lg-6">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Task Type</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="subtype" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                      [options]="toDoTasksEntityType"
                      [(ngModel)]="searchOption.subtype"></p-dropdown>
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-6">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Task Title</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText type="text" size="80"
                 [(ngModel)]="searchOption.title"/>
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-6">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label pTooltip="Retrieve tasks on this date" tooltipPosition="right">Due Date</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-calendar name="dueDate" dataType="string" [dateFormat]="Format.PcalendarDate" icon="fa fa-calendar" showIcon="true"
                      [(ngModel)]="searchOption.dueDate"></p-calendar>
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-6">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Assigned By</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-autoComplete name="userName" class="autoComplete" field="fullName" [minlength]="Validation.AutoCompleteMinLength"
                          [placeholder]="PrimeNgConfig.AutoCompletePlaceholder" [showEmptyMessage]="true" [dropdown]="true"
                          [suggestions]="users"
                          [(ngModel)]="assignedBy"
                          (completeMethod)="searchUser($event.query)"
                          (onSelect)="onSelectUser(assignedBy)">
          </p-autoComplete>
        </div>
      </div>
    </div>

    <div class="p-col-12">
      <div class="p-grid">
        <div class="p-col-12 p-md-2 p-lg-2"></div>
        <div class="p-col-12 p-md-10 p-lg-10">
          <button pButton class="inaction-secondary" icon="fa fa-eraser" label="Clear" (click)="onClickClearSearchOptionTask()">
          </button>
          <button pButton class="action-secondary" icon="fa fa-search" label="Search" (click)="onClickSearchTodoTasks(searchOption)">
          </button>
        </div>
      </div>
    </div>

  </div>

  <!-- show approval status in a dialog when called -->
  <app-approval-status [request]="approvalStatusRequest"></app-approval-status>

  <!-- div required to enable the above buttons -->
  <div style="clear:both;"></div>

  <div *ngIf="activeTab===WorklistType.User || activeTab===WorklistType.Group">

    <p-contextMenu #cm [model]="menuItem"></p-contextMenu>

    <app-data-table [columns]="tableColumns" [value]="activeWorklist" [sortField]="sortField"
                    [(contextMenuSelection)]="selectedWorkItem" [contextMenu]="cm" [rightCaptionTemplate]="rightCaption">

      <ng-template #rightCaption>
        <button pButton class="action-secondary" (click)="dt.exportCSV()">
          <i class="fa fa-download" style="padding-right:5px;"></i>
        </button>
      </ng-template>

      <ng-template #actionWorklistTemplate let-row="row">
        <button pButton type="button" class="icon-action" icon="fa fa-external-link" (click)="onClickShowWorkItemDetail(row)">
        </button>
      </ng-template>

    </app-data-table>

    <div class="p-col-12" style="text-align:right;margin-top:10px;">
      <button pButton class="action-secondary" icon="fa fa-refresh" label="Reload" (click)="onClickReloadWorklist()">
      </button>
    </div>

  </div>

  <div *ngIf="activeTab===WorklistType.MyTasks">

    <app-data-table [columns]="tableColumns" [value]="myToDoTasks" [rightCaptionTemplate]="rightCaption"
                    sortField="dueDateOn">

      <ng-template #rightCaption>
        <button pButton class="action-secondary" (click)="dt.exportCSV()">
          <i class="fa fa-download" style="padding-right:5px;"></i>
        </button>
      </ng-template>

      <ng-template #actionTaskTemplate let-row="row">
        <button pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Update TO-DO task" tooltipPosition="top"
                (click)="onClickEditToDoTask(row)">
        </button>
      </ng-template>

    </app-data-table>

  </div>


  <p-dialog *ngIf="selectedWorkItem&&displayDialog" [(visible)]="displayDialog"
            header="Work Item Detail" [dismissableMask]="true" [responsive]="true" [modal]="true" [draggable]="false" [resizable]="false"
            [style]="PrimeNgConfig.DialogStyle65" styleClass="worklist-notification">
    <form #dialogForm="ngForm">

      <p-tabView (onChange)="handleTabChange($event.index)" [activeIndex]="workItemDetailTabIndex">
        <p-tabPanel header="Review">
          <div class="p-col-12">
            <div style="max-width: 500px;" [innerHTML]="selectedWorkItem.detail"></div>

            <div *ngIf="selectedWorkItem.refId&&selectedWorkItem.transaction===TxnType.JobCandidateInterview" class="p-col-12">
              <a [routerLink]="[RouteLink.CandidateInterview, selectedWorkItem.refId]" routerLinkActive="active">Interview Feedback</a>
            </div>

            <div *ngIf="selectedWorkItem.refId&&selectedWorkItem.transaction&&selectedWorkItem.pdfTemplateId" class="p-grid">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label>Review the request (PDF)</label>
              </div>
              <div class="p-col-12 p-md-8 p-lg-8">
                <button *ngIf="viewFileInNewTab"
                        pButton type="button" class="icon-action" icon="fa fa-eye"
                        pTooltip="View PDF" tooltipPosition="top"
                        (click)="onClickViewFile(selectedWorkItem.transaction, selectedWorkItem.refId, selectedWorkItem.pdfTemplateId)">
                </button>
                <button pButton type="button" class="icon-action" icon="fa fa-download"
                        pTooltip="Download PDF" tooltipPosition="top"
                        (click)="onClickDownloadFile(selectedWorkItem.transaction, selectedWorkItem.refId, selectedWorkItem.pdfTemplateId)">
                </button>
              </div>
            </div>
            <div class="p-col-12"></div>
            <div class="p-grid">
              <div class="p-col-12 p-md-2 p-lg-2">
                <label>Your Action*</label>
              </div>
              <div class="p-col-12 p-md-10 p-lg-10">
                <p-dropdown name="selectStatus" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{'overflow':'visible','width':'225px'}"
                            [options]="nextStatusMenu"
                            [(ngModel)]="selectedStatus"
                            required></p-dropdown>
              </div>
            </div>
            <div *ngIf="selectedStatus && selectedStatus !== ApprovalStatusType.Approved" class="p-grid" style="margin-top:10px;">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label>Comment</label>
              </div>
              <div class="p-col-12 p-md-8 p-lg-8">
              <textarea pInputTextarea name="responseMessage" [rows]="Validation.DescriptionRows" [cols]="Validation.DescriptionColumns" [maxlength]="Validation.DescriptionMaxLength"
                        style="max-width:225px;height:75px!important;"
                        [(ngModel)]="responseMessage">
		       		</textarea>
              </div>
            </div>
            <div style="clear:both;"></div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="History">
          <ng-template pTemplate="content">
            <div class="p-col-12">
              <app-approval-status [request]="approvalStatusRequestInTab"></app-approval-status>
            </div>
          </ng-template>
        </p-tabPanel>

        <p-tabPanel header="Attachment">
          <ng-template pTemplate="content">
            <app-file-explorer *ngIf="loadFileExplorer && selectedWorkItem && selectedWorkItem.transaction!==TxnType.NewHireRequest"
                               [displayMode]="FileExplorerDisplay.FileExplorer" [editable]="false"
                               [forceApproverCheck]="true" [refId]="selectedWorkItem.refId" [txnType]="selectedWorkItem.transaction">
            </app-file-explorer>
            <div class="p-grid">
              <div *ngIf="loadFileExplorer && selectedWorkItem && selectedWorkItem.transaction===TxnType.NewHireRequest" class="p-col-12 p-md-12 p-lg-12">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Onboard File Type</label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-dropdown name="onboardTxnType" [placeholder]="Validation.DropdownPlaceholder"
                              [options]="onboardTxnTypeDropdown"
                              [(ngModel)]="onboardDocType"></p-dropdown>
                </div>
              </div>
            </div>

            <app-file-explorer *ngIf="loadFileExplorer && selectedWorkItem && selectedWorkItem.transaction===TxnType.NewHireRequest"
                               [displayMode]="FileExplorerDisplay.FileExplorer" [docTypeFilter]="onboardDocType" [editable]="false"
                               [forceApproverCheck]="true" [refId]="selectedWorkItem.refId" [txnType]="TxnType.NewHireRequest" [userId]="workItemUserId">
            </app-file-explorer>
          </ng-template>
        </p-tabPanel>

        <p-tabPanel header="Notification">
          <ng-template pTemplate="content">

            <!--            ToDo jC: rel-1.3 remove after testing-->
            make sure Show Notification Message works
            <p-table [columns]="notificationTableColumns" [value]="notifications" dataKey="id" [rows]="10" [responsive]="true" #dt [paginator]="true" selectionMode="single">

              <ng-template pTemplate="caption">
                <div class="p-grid">
                  <div class="leave-request-search p-col-12 p-md-4 p-lg-4" style="text-align:left;">
                    <i class="fa fa-search"></i>
                    <input pInputText type="text" size="20" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Table Filter">
                  </div>
                </div>
              </ng-template>

              <ng-template let-columns pTemplate="header">
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>

              <ng-template let-columns="columns" let-expanded="expanded" let-row let-rowData pTemplate="body">
                <tr>
                  <td style="overflow:ellipsis;word-break:break-all;" *ngFor="let col of columns" [ngSwitch]="col.field">
                    <span class="p-column-title">{{col.header}}</span>
                    <span class="p-cell">
                      <div *ngSwitchCase="'sentOn'">
                        <span *ngIf="row.message">{{row.message[col.field] | date: Format.Date }}</span>
                      </div>
                      <div *ngSwitchCase="'htmlBody'">
                        <button *ngIf="row.message" class="icon-action" pTooltip="Show Notification Message" tooltipPosition="top" style="font-size:20px;" [pRowToggler]="rowData" href="#">
                          <i style="color:#2fcbe0;" [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                        </button>
                      </div>
                      <div *ngSwitchDefault>
                        <span *ngIf="row.message">{{row.message[col.field]}}</span>
                      </div>
                    </span>
                  </td>
                </tr>
              </ng-template>

              <ng-template let-rowData pTemplate="rowexpansion">
                <td [innerHTML]="rowData.message.htmlBody" colspan="6">
                </td>
              </ng-template>

            </p-table>

            <app-data-table [columns]="notificationTableColumns" [value]="notifications" dataKey="id" [sortField]="sortField">

              <ng-template #notificationMsgTemplate let-row="rows" let-expanded="expanded">
                <button *ngIf="row.message"
                        class="icon-action" pTooltip="Show Notification Message" tooltipPosition="top" style="font-size:20px;" [pRowToggler]="row" href="#">
                  <i style="color:#2fcbe0;" [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                </button>
              </ng-template>

            </app-data-table>

          </ng-template>
        </p-tabPanel>

      </p-tabView>
    </form>
    <p-footer>
      <div style="text-align:right;margin-top:10px;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
                (click)="onClickCancelWorkItem()"></button>
        <button pButton class="button-action" icon="fa fa-check" label="Submit"
                (click)="onClickUpdateWorkItem(selectedWorkItem, selectedStatus, responseMessage)"
                [disabled]="!dialogForm.form.valid"></button>
      </div>
    </p-footer>

    <div style="clear:both;"></div>
  </p-dialog>
  <div class="main-clear">&nbsp;</div>
</main>


<!-- dialog for adding new widget -->
<p-dialog *ngIf="taskDisplayDialog" [(visible)]="taskDisplayDialog"
          header="Manage ToDo" [dismissableMask]="true" [responsive]="true" [modal]="true"
          [style]="PrimeNgConfig.DialogStyle40" styleClass="trade-dialogs">

  <form #widgetForm="ngForm">

    <div class="p-grid">
      <div class="p-col-12">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Title*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            {{selectedToDoTask.title}}
          </div>
        </div>
      </div>
      <div class="p-col-12">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Lane*</label>
          </div>
          <div *ngIf="!selectedToDoTask.enableUserToChangeTODOStatus" class="p-col-12 p-md-8 p-lg-8">{{ selectedToDoTask.taskLaneName | titleCase }} </div>
          <p-dropdown *ngIf="selectedToDoTask.enableUserToChangeTODOStatus"
                      name="taskLaneId" [placeholder]="PrimeNgConfig.DropdownPlaceholder" style="margin-left:12px;"
                      [options]="lanesDropdown"
                      [(ngModel)]="selectedToDoTask.taskLaneId"></p-dropdown>
        </div>
      </div>
      <div class="p-col-12">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Due Date*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            {{ selectedToDoTask.duedate | date: Format.Date }}
          </div>
        </div>
      </div>


      <div class="p-col-12">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Description*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
          <textarea pInputText pInputTextarea name="description" [rows]="Validation.DescriptionRows" [cols]="Validation.DescriptionColumns" [maxlength]="Validation.DescriptionMaxLength"
                    style="height:75px !important;width:100%;"
                    [(ngModel)]="selectedToDoTask.description"
                    [readOnly]="true"></textarea>
          </div>
        </div>
      </div>
      <div class="p-col-12">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Comments</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <textarea pInputTextarea name="comment" [rows]="Validation.DescriptionRows" [cols]="Validation.DescriptionColumns" [maxlength]="Validation.DescriptionMaxLength"
                      [placeholder]="PrimeNgConfig.TextPlaceholder"
                      style="height:75px !important;width:100%;"
                      [(ngModel)]="selectedComment.comment"> </textarea>
          </div>
        </div>
      </div>
      <div *ngIf="selectedToDoTask.id" class="p-col-12">

        <div class="p-grid" style="border-top:1px solid #ccc;">
          <div class="p-col-12 p-md-4 p-lg-4"><label>Comment History</label></div>
          <div class="p-col-12 p-md-8 p-lg-8" style="font-weight:bold;" *ngFor="let c of  selectedToDoTask.taskTodoComments">
            {{c.userFullName}} {{c.displayCreatedOn| date:'medium'}}
            <div>
            <textarea pInputTextarea name="message" [rows]="5" [cols]="30" style="border:none!important;:100%;height:75px !important;margin-bottom:10px;padding:0!important" required [readonly]="true"
                      placeholder="Enter your text here"> {{c.comment}} </textarea></div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <div>
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close"
              (click)="taskDisplayDialog = false"></button>
      <button *ngIf="selectedToDoTask.id"
              pButton type="button" class="button-action" icon="fa fa-check" label="Update"
              (click)="onClickUpdateToDoTask()"
              [disabled]="!widgetForm.form.valid"></button>

    </div>
  </p-footer>
</p-dialog>
